// extracted by mini-css-extract-plugin
export default {"card":"DevCard_card__KP6Mx","colored":"DevCard_colored__q2+kd","actions":"DevCard_actions__RWByd"};